/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { BodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from 'views/components/Ext/ExtComponent';

export const AlarmsManagementPage: React.FC<{}> = () => {
    const xtype = 'rcop.configuration.alarms.Grid';

    return (
        <BodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </BodyLayout>
    );
};
